













































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { finance, FinanceService } from '@/api'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import helpers from '@/helpers'
import auth from '@/auth'
import { OrderPayedReq } from '@/apiv3'

@Component({ components: { PulseLoader } })
export default class PayAll extends Vue {
  @Prop(String) id!: string

  public data!: finance
  public loaded = false
  public amount = 0.0
  public comment = 'Карты'
  public orders: Array<string> = []
  public pay = ''
  public blocked = false
  public ids: Array<bigint> = []

  mounted (): void {
    const userId = helpers.getAmount(this.id)

    FinanceService.getFinance().then(data => {
      data.to_pay.list.forEach((val) => {
        if (val.order.user.id !== userId) {
          return
        }

        if (val.order.price === undefined || val.order.user.pay === undefined) {
          return
        }

        this.amount += val.order.price
        this.orders.push(val.order.number)
        this.pay = val.order.user.pay
        this.ids.push(BigInt(val.order.id))
      })
    }).finally(() => {
      this.loaded = true
    })
  }

  payOrders () {
    this.blocked = true

    const req: OrderPayedReq = {
      ids: this.ids,
      payComment: this.comment
    }

    auth.adminClient().OrderPayed(req).then(() => {
      this.$router.push('/adm/finance')
    }).finally(() => {
      this.blocked = false
    })
  }
}
